import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "material-icons/iconfont/material-icons.css";
import "material-symbols/outlined.css";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "./assets/darkmode.css";
import "./assets/styles/animal-status-cards.css";
import "./assets/styles/hero-header.css";
import "./registerServiceWorker";

import notificationPlugin from "./plugins/notificationPlugin";
import ToastNotification from "./components/ToastNotification.vue";
import permissionDirective from "./directives/permission";

// ============================================================
// DARK MODE: Aplicar tema guardado antes del mount para evitar
// flash de contenido blanco (FOUC)
// ============================================================
const savedTheme = localStorage.getItem("tambopal-theme") || "light";
document.documentElement.setAttribute("data-bs-theme", savedTheme);

import { getDisplayName } from "./store/lotesStore.js";
import apiTamboUrl from "./services/api";

const app = createApp(App);

app.config.globalProperties.$getDisplayName = getDisplayName;
app.config.globalProperties.$http = apiTamboUrl;
app.config.globalProperties.$api = apiTamboUrl;

app.component("VueMultiselect", Multiselect);
app.component("ToastNotification", ToastNotification);

// Registrar directiva de permisos globalmente
app.directive("permission", permissionDirective);

// ============================================================
// MANEJO GLOBAL DE ERRORES DE CÓDIGO Y SISTEMA
// ============================================================
app.config.errorHandler = (err, instance, info) => {
  console.error("❌ [Error Global Vue]:", err, info);
  // Si no es un error de Axios (que ya se maneja en los servicios/componentes)
  if (!err?.isAxiosError && err?.name !== "AxiosError") {
    store.dispatch("notificationStore/error", {
      title: "Error del Sistema",
      message: `Error interno en la aplicación (${
        err?.message || "error de procesamiento"
      }). Por favor, comuníquese con soporte técnico (+54 9 3576 657682).`,
      duration: 10000,
      contactSupport: true,
      errorDetails: err?.stack || err?.message,
    });
  }
};

window.addEventListener("unhandledrejection", (event) => {
  const error = event.reason;
  console.error("❌ [Promesa no capturada]:", error);
  if (error && !error._handledByApp) {
    const isAxios = error?.isAxiosError || error?.name === "AxiosError";
    const status = error?.response?.status;
    const isServerOrCode =
      !isAxios || (status && status >= 500) || !error?.response;

    if (isServerOrCode) {
      store.dispatch("notificationStore/error", {
        title: "Error del Sistema",
        message: `Error de comunicación o procesamiento interno. Por favor, comuníquese con soporte técnico (+54 9 3576 657682).`,
        duration: 10000,
        contactSupport: true,
        errorDetails: error?.message || null,
      });
    }
  }
});

app.use(store).use(router).use(notificationPlugin).mount("#app");
